'use client'

import Link from 'next/link'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'next/image'

export default function Blogs({ data = [] }) {
  const loopEnabled = data.length > 1
  const swiperOptions = {
    autoplay: { delay: 5000 },
    modules: [Autoplay],
    slidesPerView: 3,
    slidesPerGroup: 3,
    effect: 'none',
    loop: loopEnabled,
    breakpoints: {
      320: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 14 },
      768: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 24 },
      992: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 30 },
    },
  }

  // 圖片來源（相容兩種格式）
  const getCover = (a) =>
    a?.PicturePath ||
    a?.CoverPath ||
    a?.Cover ||
    a?.ImageUrl ||
    a?.Album?.[0]?.PicturePath ||
    a?.PictureData?.[0]?.PicturePath ||
    a?.ComputerPicturePath ||          // ← HomeContent BLO01
    '/images/placeholder/placeholder-600.png'

  // 連結（先吃 HomeContent 的 LinkURL/LinkURLPagePara，再退回文章 slug/id）
  const getHref = (a) => {
    if (a?.LinkURL) {
      const base = a.LinkURL.trim().replace(/\/$/, '')
      const para = (a?.LinkURLPagePara ?? '').toString().trim()
      return para ? `${base}/${para}` : base
    }
    const id = a?.ArticleID
    const slug = (a?.ArticleSlug || 'news').toString().trim() || 'news'
    return id ? `/blogs-list/${slug}/${id}` : `/blogs-list/${slug}`
  }

  const getTitle = (a) =>
    a?.ArticleTitle || a?.Title || 'Latest News'

  const getDateText = (a) =>
    a?.PublishDataFormatted || a?.PublishDate || '' // HomeContent 可能沒有日期

  return (
    <section className="blog-carousel container">
      <h2 className="section-title fw-normal text-center text-uppercase mb-3 pb-xl-3 mb-xl-3">
        Latest News
      </h2>

      <div className="position-relative">
        <Swiper className="swiper-container js-swiper-slider" {...swiperOptions}>
          {data.map((elm, i) => {
            const src = getCover(elm)
            const isPriority = i < 2 // 前兩張優先載入
            return (
              <SwiperSlide key={i} className="swiper-slide blog-grid__item mb-4">
                <div
                  className="blog-grid__item-image"
                  style={{
                    position: 'relative',
                    width: '100%',
                    aspectRatio: '16 / 9',
                    overflow: 'hidden',
                    borderRadius: 6,
                  }}
                >
                  <Image
                    src={src}
                    alt={getTitle(elm)}
                    fill
                    sizes="(max-width: 576px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    style={{ objectFit: 'cover' }}
                    priority={isPriority}
                  />
                </div>

                <div className="blog-grid__item-detail">
                  <div className="blog-grid__item-meta">
                    {getDateText(elm) && (
                      <span className="blog-grid__item-meta__date">
                        {getDateText(elm)}
                      </span>
                    )}
                  </div>
                  <div className="blog-grid__item-title mb-0 blog-title">
                    <Link href={getHref(elm)}>{getTitle(elm)}</Link>
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </section>
  )
}
